import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { Url, URLS } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
import s from './SaleBanner.scss';
const SaleBanner = ({ discountValuePercent , endDate , isNarrow , giftRecipient , referralType , className  })=>{
    const { t , i18n  } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isGift = !!giftRecipient;
    const localeKeys = getLocaleKeys(isGift, isMobile, isNarrow);
    const isShowingPreamble = !isNarrow && !isMobile;
    const href = giftRecipient ? Url.giveCoreMembership(giftRecipient) : URLS.CORE_MEMBERSHIP;
    return /*#__PURE__*/ React.createElement(PromoBanner, {
        className: className,
        variant: "core",
        size: isNarrow ? 'small' : 'big',
        messageBeforeIcon: isShowingPreamble ? t(localeKeys.preamble, {
            username: giftRecipient
        }) : undefined,
        icon: isGift ? /*#__PURE__*/ React.createElement(GiftIcon, {
            className: s['gift-icon'],
            size: IconSize.SMALLER
        }) : /*#__PURE__*/ React.createElement(CoreIcon, {
            size: IconSize.SMALLER
        }),
        messageAfterIcon: t(localeKeys.sale, {
            sale: discountValuePercent,
            date: endDate ? formatDate(endDate, DATE_FORMATS.Date.DayLongMonth, i18n.language) : undefined
        }),
        ctaLabel: t(localeKeys.button),
        ctaHref: href,
        ctaBiData: {
            evid: BiEventType.BUY_CORE_BUTTON,
            referral_info: referralType
        }
    });
};
SaleBanner.displayName = 'SaleBanner';
export default SaleBanner;
function getLocaleKeys(isGift, isMobile, isNarrow) {
    // saleBanner.mobile.preamble
    // saleBanner.mobile.sale
    // saleBanner.mobile.button
    // saleBanner.narrow.preamble
    // saleBanner.narrow.sale
    // saleBanner.narrow.button
    // saleBanner.preamble
    // saleBanner.sale
    // saleBanner.button
    // saleBanner.gift.mobile.preamble
    // saleBanner.gift.mobile.sale
    // saleBanner.gift.mobile.button
    // saleBanner.gift.narrow.button
    // saleBanner.gift.preamble
    // saleBanner.gift.sale
    // saleBanner.gift.button
    let keyBase = 'saleBanner';
    if (isGift) {
        keyBase += '.gift';
    }
    if (isMobile) {
        keyBase += '.mobile';
    } else if (isNarrow) {
        keyBase += '.narrow';
    }
    return {
        preamble: `${keyBase}.preamble`,
        sale: `${keyBase}.sale`,
        button: `${keyBase}.button`
    };
}
